import { motion, useReducedMotion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const M = motion[as];
  return (
    <M
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.8, delay, ease }}
    >
      {children}
    </M>
  );
};

// Masked line-by-line headline reveal; runs on mount.
export const SplitHeadline = ({ lines, className = "", delay = 0.1, accentLast = false, inView = false, testId }) => {
  const reduce = useReducedMotion();
  const trigger = inView
    ? { whileInView: { y: "0%" }, viewport: { once: true, amount: 0.1 } }
    : { animate: { y: "0%" } };
  return (
    <h1 className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={line} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${accentLast && i === lines.length - 1 ? "text-flame" : ""}`}
            initial={reduce ? false : { y: "105%" }}
            {...trigger}
            transition={{ duration: 1.05, delay: delay + i * 0.12, ease }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
};

export const SectionHead = ({ eyebrow, title, intro, dark = false, className = "" }) => (
  <Reveal className={`max-w-3xl ${className}`}>
    {eyebrow && <p className={`eyebrow mb-5 ${dark ? "text-flame" : "text-flame-600"}`}>{eyebrow}</p>}
    <h2 className={`text-3xl font-extrabold leading-[1.02] tracking-tight sm:text-4xl lg:text-5xl ${dark ? "text-white" : "text-navy"}`}>{title}</h2>
    {intro && <p className={`mt-5 max-w-2xl text-base leading-relaxed md:text-lg ${dark ? "text-slate-300" : "text-slate-600"}`}>{intro}</p>}
  </Reveal>
);
